// mailStats.js — Versand-Statistik aus Mailjet über die Edge Function
// "mail-stats". Zeigt, ob die Mails der Praxis wirklich gelesen werden.
//
// Demo/Sandbox: kein Serverkontakt — die Karte zeigt dort einen Hinweis
// statt erfundener Öffnungsraten.
import { supabase } from "./supabase";
import { serverActive } from "./mode";

export async function loadMailStats(tage = 30) {
  if (!serverActive()) return { ok: false, demo: true };
  const { data, error } = await supabase.functions.invoke("mail-stats", { body: { tage } });
  if (error) {
    let msg = "";
    try { const b = await error.context?.json?.(); msg = b?.error || ""; } catch {}
    throw new Error(msg || error.message || "mail-stats nicht erreichbar — ist die Function deployt?");
  }
  if (data?.error) throw new Error(data.error);
  return data;
}

// Quote in Prozent — ohne Versand gibt es keine Quote (nicht 0 %).
export const quote = (teil, ganzes) =>
  ganzes > 0 ? Math.round((teil / ganzes) * 100) : null;
